/**
 * GroupPay status codes
 * https://onyxpayments.atlassian.net/wiki/display/PION/GroupPay+Status+Codes
 */
export enum ReservationStatusCode {
  RESERVED = <any>'R',
  CHECKED_IN = <any>'I',
  CHECKED_OUT = <any>'O',
  CANCELLED = <any>'C',
  NO_SHOW = <any>'N'
}

export type StatusCodeRsvpType = 'RSVP';
export const STATUS_CODE_RSVP: StatusCodeRsvpType = 'RSVP';

export type ReservationCompareStatusCode = ReservationStatusCode | StatusCodeRsvpType;

export const OVERVIEW_STATUS_CODES: ReservationStatusCode[] = [
                                      ReservationStatusCode.RESERVED,
                                      ReservationStatusCode.CHECKED_OUT,
                                      ReservationStatusCode.CHECKED_IN ];



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/reservation-status-code.enum.ts